import CrypteLocalstroge from "./CrypteLocalstroge";

export const setMyRole = (customer) => {
  const role = { key: JSON.stringify(customer) };
  const encryptedCustomer = CrypteLocalstroge(role, "ENCRYPT");
  localStorage.setItem("custID", encryptedCustomer);
  return customer;
};
